import { buildInFilter, type GridFilters } from '@/ui/composites/grid/gridFilters';

export const buildStagePipelineFilters = (pipelineIds: string[]): GridFilters =>
  buildInFilter('pipelineId', pipelineIds);

export const buildStageNameFilters = (stageNames: string[]): GridFilters =>
  buildInFilter('stageName', stageNames);
